import OpenInNew from "@mui/icons-material/OpenInNew";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * "Amend in the waste facility overview" CTA shown at the top of the (read-only)
 * Waste Activity step. The underlying data (generator status, waste streams,
 * reportable codes) is computed from manifest/vendor lines, so edits happen on
 * the waste facility overview page rather than inline in the stepper.
 *
 * Opens the facility overview in a new tab so the user keeps their stepper
 * position.
 */
export function AmendInWasteOverviewLink({
  tenantId,
  facilityId,
}: {
  tenantId: string;
  facilityId: string;
}) {
  return (
    <Link
      component={RouterLink}
      to={`/o/${tenantId}/waste/facilities/${facilityId}`}
      target="_blank"
      rel="noopener"
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
    >
      Amend in the waste facility overview
      <OpenInNew fontSize="inherit" />
    </Link>
  );
}
